import { Breadcrumbs } from '@lightspeed/design-system-react'
import * as React from 'react'
import { useT } from '@transifex/react'
import { STEPS } from './types'

export const BREADCRUMBS = ['Customer', 'Details']
export const BREADCRUMBS_WITH_ADD = ['Customer', 'Add', 'Details']

interface Props {
  step: STEPS
  isAddingCustomer?: boolean
}

const getActiveBreadcrumb = (step: STEPS, isAddingCustomer: boolean) => {
  const breadcrumbs = isAddingCustomer ? BREADCRUMBS_WITH_ADD : BREADCRUMBS

  if (step === STEPS.REVIEW_DETAILS && !isAddingCustomer) {
    return breadcrumbs[step - 2]
  }
  return breadcrumbs[step - 1]
}

export const StepBreadcrumbs: React.FC<Props> = ({
  step,
  isAddingCustomer = false,
}) => {
  const t = useT()
  const breadcrumbContext = 'Breadcrumb text in quotes modal'
  const breadcrumbMapping = BREADCRUMBS.map(breadcrumb => {
    return t(breadcrumb, {
      _context: breadcrumbContext,
    })
  })
  const breadcrumbWithAddMapping = BREADCRUMBS_WITH_ADD.map(breadcrumb => {
    return t(breadcrumb, {
      _context: breadcrumbContext,
    })
  })

  return (
    <Breadcrumbs
      breadcrumbs={
        isAddingCustomer ? breadcrumbWithAddMapping : breadcrumbMapping
      }
      activeBreadcrumb={getActiveBreadcrumb(step, isAddingCustomer)}
    />
  )
}
